import lodashThrottle from 'lodash.throttle'

export const throttle = lodashThrottle
